export default "__VITE_ASSET__1cb65063__"